import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL } from "../Config";
import RepairPDFImageListScreen from "./RepairPDFImageListScreen";

function RepairPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Repair PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/repair_pdf", title: "Fix Corrupted PDF Files" },
    data2: { link: "/repair_pdf", title: "PDF Repair Tool" },
    data3: { link: "/repair_pdf", title: "Retrieve Corrupted PDF Pages" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Repair PDF files online easily. Fix corrupted or damaged PDFs and restore documents quickly with our fast and secure PDF repair tool."
      ></meta>
      <meta
        name="keywords"
        content="repair pdf, pdf repair tool, fix pdf, repair pdf online, corrupted pdf repair, damaged pdf fix, pdf file repair, recover pdf files, pdf fixer, online pdf repair, restore pdf document, pdf error fix, fix broken pdf, pdf recovery tool, secure pdf repair"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <RepairPDFImageListScreen title={title}></RepairPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="This repair PDF website that works offline is a reliable solution for fixing damaged, corrupted, or unreadable PDF files without depending on an internet connection. Our offline PDF repair tool helps recover broken PDFs caused by incomplete downloads, system crashes, file transfer errors, or software issues. By processing files locally, a repair PDF tool ensures maximum privacy and security, making it ideal for sensitive documents used by businesses, professionals, and institutions. Users can quickly repair PDF files offline, restore document structure, fix missing pages, and recover readable text while preserving original formatting. This offline PDF repair solution is fast, stable, and works even in restricted or low-connectivity environments. It supports a wide range of PDF versions and file sizes, making it suitable for everyday document recovery needs. Whether you need to fix a corrupted invoice, report, form, or scanned document, a repair PDF website offers an efficient and secure way to restore files and continue working without data loss." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Repair",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Repair Tool"
            why_use={[
              {
                title: "Fix Corrupted and Damaged PDF Files",
                description:
                  "Our repair PDF website helps fix corrupted, damaged, or unreadable documents caused by download errors or system crashes. Using a PDF repair tool makes it easy to repair PDF files quickly.",
              },
              {
                title: "Work Offline for Maximum Privacy",
                description:
                  "This offline repair PDF tool processes files locally, ensuring data security and privacy. Repair PDF offline is ideal for confidential and sensitive documents.",
              },
              {
                title: "Recover Important Data and Content",
                description:
                  "PDF repair tools help recover text, images, and document structure from broken files, preventing data loss and saving time.",
              },
              {
                title: "Restore PDFs Without Recreating Files",
                description:
                  "Using a repair PDF website eliminates the need to recreate documents from scratch by fixing existing PDF files efficiently.",
              },
              {
                title: "Fast and Reliable Document Recovery",
                description:
                  "Offline PDF repair tools provide fast and stable performance without relying on internet connectivity.",
              },
              {
                title: "Support for Multiple PDF Versions",
                description:
                  "Our PDF repair tool supports different PDF versions and file sizes, making it suitable for repairing a wide range of documents.",
              },
              {
                title: "Useful for Business and Professional Use",
                description:
                  "Professionals and businesses rely on repair PDF tools to fix invoices, reports, contracts, and official documents.",
              },
              {
                title: "Easy to Use and Beginner-Friendly",
                description:
                  "Our repair PDF website offers a simple interface that allows users to repair PDF files without technical knowledge.",
              },
              {
                title: "Save Time and Reduce Downtime",
                description:
                  "Repairing PDF files quickly helps avoid delays and interruptions in work caused by corrupted documents.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default RepairPDFMain;
